module.exports = __webpack_public_path__ + "static/media/7_file_import_requirements_and_best_practices.f5e87431.png";